export const SUBSCRIPTION_CONSTANTS = {
  MIN_QUANTITY: 1,
  MAX_QUANTITY: 10,
  FREE_PLAN_QUANTITY: 1,

  DURATION_MULTIPLIERS: {
    free: 0,
    monthly: 1,
    annual: 12,
    lifetime: 120
  },

  DURATION_DISCOUNTS: {
    monthly: 0,
    annual: 0.10,
    lifetime: 0
  },

  DEFAULT_DISCOUNTS: {
    monthly: 0.10,
    annual: 0.20,
    lifetime: 0.50,
    quantityStep: 2,
    maxDiscount: 0.50
  }
}
